var React = require('react');

function HamburgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"2","rx":"1","fill":"#919CB5","key":0}),React.createElement("rect",{"y":"4","width":"20","height":"2","rx":"1","fill":"#919CB5","key":1}),React.createElement("rect",{"y":"8","width":"20","height":"2","rx":"1","fill":"#919CB5","key":2})]);
}

HamburgerMenu.defaultProps = {"width":"20","height":"10","fill":"none"};

module.exports = HamburgerMenu;

HamburgerMenu.default = HamburgerMenu;
